import './layout-style.scss'
import './layout.css'

import React, { useState } from 'react'

import { useUserRegion } from '@/hooks'
import { withTrans } from '@/i18n/withTrans'
import { useCommonComps } from '@/modules/components/layout/useCommonComps'
import { useRestrictedBanner } from '@/utils/useRestrictedBanner'

import TaxBanner from '../banner/TaxBanner'
import SearchBar from '../search/search'

const Layout = ({ isTrendingPage, children }) => {
  const userRegion = useUserRegion()
  const { Nav, Footer } = useCommonComps(userRegion.toLowerCase())
  const [isBannerOpen, setBannerClose] = useState(true)

  let isBannerRestricted = useRestrictedBanner()

  return (
    <div className="global-wrapper" data-is-root-path={isTrendingPage}>
      <Nav />
      {isBannerOpen && !isBannerRestricted && (
        <TaxBanner curKey={children.key} setBannerClose={setBannerClose} />
      )}
      <main className="container">{children}</main>
      <div className="container-footer">
        <Footer />
      </div>
      <SearchBar />
    </div>
  )
}

export default withTrans(Layout)
